module.exports = __webpack_public_path__ + "static/media/mail.c6ab692e.jpg";